module.exports = __webpack_public_path__ + "static/img/hzhb.32ecded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/hzhb.jpg
// module id = S6dG
// module chunks = 11